<template>
  <f7-page class="no-swipeback" id="mandate-dbtr">
    <div class="mandate-dbtr-wrapper">
      <page-outline :title="$t('mandate.dbtr_mandate_pagetitle')">
        <template #pageContent>
          <b-container fluid>
            <b-row class="justify-content-center">
              <b-col cols="12" class="mt-3">
                <!-- === MODE AVANT SIGNATURE (édition) === -->
                <!-- DocuSign embedded signing: affiché automatiquement après createEnvelope -->
                <div v-if="docusignUrl" class="docusign-signing-container">
                  <iframe
                    :src="docusignUrl"
                    class="docusign-signing-iframe"
                    frameborder="0"
                    allow="clipboard-write"
                  ></iframe>
                </div>

                <div v-else-if="!signedViewMode">
                  <!-- Mandate info (lecture côté débiteur) -->
                  <form-accordion
                    v-if="isDbtr"
                    :title="$t('mandate.mandate_info')"
                    :isTitleUpperCase="false"
                  >
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.tx_type')"
                          :inputValue="$t(`mandate.${active}`)"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.creation_date') || 'Creation date'"
                          :inputValue="formattedCreationDate"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate_details.message_type') || 'Message type'"
                          :inputValue="message_type"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.underlying_contract_id')"
                          :inputValue="ctrDisplay"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.reason_mandate') || 'Reason'"
                          :inputValue="reason_mandate"
                        />
                      </b-col>

                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate_details.status') || 'Status'"
                          :inputValue="mandateStatusLabel"
                        />
                      </b-col>
                    </b-row>
                  </form-accordion>
                  <!-- Debtor info (éditable + prérempli) -->
                  <form-accordion
                    v-if="isDbtr"
                    :title="$t('mandate.dbtr_info')"
                    :isTitleUpperCase="false"
                  >
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <iban-input
                          v-if="String(mode_sign) !== '3'"
                          ref="dbtrIbanInput"
                          v-model="dbtr_iban"
                          :label="$t('mandate.dbtr_iban')"
                          :required="true"
                          :hint="$t('mandate.iban_hint') || ''"
                          isMandatory
                        />
                        <div v-else>
                          <template v-if="!dbtr_iban">
                            <b-button v-if="!dbtr_iban"
                              class="btnFilter_2"
                              :disabled="!urlAisp"
                              @click="openAisp"
                            >
                              {{ $t('mandate.get_iban') }}
                            </b-button>
                          </template>

                          <form-read-group-label-input
                            v-else
                            :inputLabel="$t('mandate.dbtr_iban')"
                            :inputValue="dbtr_iban"
                          />
                      </div>
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_name')"
                          :inputValue="dbtr_name"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">

                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_email') || 'Email'"
                          :inputValue="dbtr_email"
                        />
                      </b-col>

                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_addr') || 'Address'"
                          :inputValue="dbtr_addr"
                        />
                      </b-col>
                      <!--
                      <b-col sm="5">
                        <form-write-group-label-input
                          v-model="dbtr_bic"
                          :inputLabel="$t('mandate.dbtr_bic') || 'BIC'"
                        />
                      </b-col>
                      -->
                    </b-row>
                    <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_city') || 'City'"
                          :inputValue="dbtr_city"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.cdtr_ctry') || 'Country of residence'"
                          :inputValue="dbtr_country"
                        />
                      </b-col>
                    </b-row>

                    <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">


                    </b-row>
                    <!-- Checkbox Third party debtor -->
                    <b-row class="ml-0 mt-3 mb-2 mr-5 form-group align-items-center">
                      <b-col sm="10">
                        <b-form-checkbox :checked="hasThirdPartyDebtor" disabled>
                          Third party debtor (different from the debited account holder)
                        </b-form-checkbox>
                      </b-col>
                    </b-row>

                    <!-- Champs tiers débiteur -->
                    <div v-if="hasThirdPartyDebtor">
                      <b-row class="ml-0 mt-5 mb-4 mr-5 form-group">
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor BIC"
                            :inputValue="dbtrPSP_bic || '—'"
                          />
                        </b-col>
                      </b-row>

                      <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor name"
                            :inputValue="dbtrPSP_name || '—'"
                          />
                        </b-col>
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor address"
                            :inputValue="dbtrPSP_addr || '—'"
                          />
                        </b-col>
                      </b-row>

                      <b-row class="ml-0 mt-2 mb-6 mr-5 form-group">
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor city"
                            :inputValue="dbtrPSP_city || '—'"
                          />
                        </b-col>
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor country"
                            :inputValue="dbtrPSP_ctry || '—'"
                          />
                        </b-col>
                      </b-row>
                    </div>
                  </form-accordion>

                  <!-- Langue du mandat -->
                  <b-row
                    v-if="showMandateLanguage"
                    class="ml-0 mt-4 mb-3 mr-5 form-group"
                  >
                    <b-col sm="5">
                      <label class="mb-2">
                        {{ $t('mandate.mandate_language') || 'Langue du mandat' }}
                      </label>

                      <b-form-radio-group
                        v-model="mandateLanguage"
                        name="mandate-language"
                        :disabled="true"
                      >
                        <b-form-radio
                          v-for="option in mandateLanguageOptions"
                          :key="option.value"
                          :value="option.value"
                        >
                          {{ option.text }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-col>
                  </b-row>

                  <!-- Boutons débiteur -->
                  <b-row
                    v-if="isDbtr"
                    class="min-w-100 justify-content-end align-items-center"
                  >
                    <b-col cols="12" class="d-flex justify-content-end mt-3">
                      <b-button
                        class="btnFilter_2 mr-2"
                        :disabled="!canAccept || isSubmitting"
                        @click="onSend"
                      >
                        {{ $t('mandate.accept') || 'Accept & Sign' }}
                      </b-button>
                      <b-button
                        class="back-button btnFilter_2"
                        :disabled="isSubmitting"
                        @click="onRefuse"
                      >
                        {{ $t('mandate.refus') || 'Refuse' }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                <!-- === MODE APRÈS SIGNATURE (lecture seule + download) === -->
                <div v-else>
                  <!-- Mandate info -->
                  <form-accordion
                    v-if="isDbtr"
                    :title="$t('mandate.mandate_info')"
                    :isTitleUpperCase="false"
                  >
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.tx_type')"
                          :inputValue="$t(`mandate.${active}`)"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.creation_date') || 'Creation date'"
                          :inputValue="formattedCreationDate || '—'"
                        />
                      </b-col>
                    </b-row>

                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.underlying_contract_id')"
                          :inputValue="ctrDisplay || '—'"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.reason_mandate') || 'Reason'"
                          :inputValue="reason_mandate || '—'"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate_details.status') || 'Status'"
                          :inputValue="mandateStatusLabel"
                        />
                      </b-col>
                    </b-row>

                  </form-accordion>

                  <!-- Debtor info lecture seule -->
                  <form-accordion
                    v-if="isDbtr"
                    :title="$t('mandate.dbtr_info')"
                    :isTitleUpperCase="false"
                  >
                    <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_iban')"
                          :inputValue="dbtr_iban|| '—'"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_name')"
                          :inputValue="dbtr_name|| '—'"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_email') || 'Email'"
                          :inputValue="dbtr_email|| '—'"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_addr') || 'Address'"
                          :inputValue="dbtr_addr|| '—'"
                        />
                      </b-col>
                      <!--
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_bic') || 'BIC'"
                          :inputValue="dbtr_bic|| '—'"
                        />
                      </b-col>
                      -->
                    </b-row>

                    <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_city') || 'City'"
                          :inputValue="dbtr_city|| '—'"
                        />
                      </b-col>
                      <b-col sm="5">
                        <form-read-group-label-input
                          :inputLabel="$t('mandate.dbtr_country') || 'Country'"
                          :inputValue="iso2ToCountryName(dbtr_country)|| '—'"
                        />
                      </b-col>
                    </b-row>
                  </form-accordion>
                  <form-accordion
                    v-if="hasThirdPartyDebtor || dbtrPSP_name || dbtrPSP_bic || dbtrPSP_addr || dbtrPSP_city || dbtrPSP_ctry"
                    :title="'Third party debtor'"
                    :isTitleUpperCase="false"
                  >

                      <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">

                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor BIC"
                            :inputValue="dbtrPSP_bic || '—'"
                          />
                        </b-col>
                      </b-row>

                      <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor name"
                            :inputValue="dbtrPSP_name || '—'"
                          />
                        </b-col>
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor address"
                            :inputValue="dbtrPSP_addr || '—'"
                          />
                        </b-col>
                      </b-row>

                      <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor city"
                            :inputValue="dbtrPSP_city || '—'"
                          />
                        </b-col>
                        <b-col sm="5">
                          <form-read-group-label-input
                            inputLabel="Third party debtor country"
                            :inputValue="dbtrPSP_ctry || '—'"
                          />
                        </b-col>
                      </b-row>
                    </form-accordion>
                    <form-accordion title="Date"
                    :isTitleUpperCase="false">
                  <!-- Signed / Refused date (auto) -->
                  <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
                    <b-col sm="5">
                      <form-read-group-label-input
                      :inputLabel="outcomeDateLabel"
                      :inputValue="formattedOutcomeDate"
                      />
                    </b-col>
                  </b-row>
                  </form-accordion>

                  <b-row class="mt-5 mb-4">
                    <b-col sm="12">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.qr_help')"
                        >
                      </form-read-group-label-input>
                      <div class="ml-5">
                        <img
                          v-if="qrCodeDataUrl"
                          :src="qrCodeDataUrl"
                          alt="Mandate access QR Code"
                          style="max-width: 180px;"
                        >
                      </div>


                      <!-- afficher le lien brut sous le QR -->
                      <!--
                      <p v-if="qrTargetUrl" class="mt-2 small text-muted text-center">
                       {{ qrTargetUrl }}
                      </p>-->
                    </b-col>
                  </b-row>
                  <!-- Bouton téléchargement -->
                  <b-row class="min-w-100 justify-content-end align-items-center">
                    <b-col cols="12" class="d-flex justify-content-end mt-3">
                      <b-button
                        v-if="(signedPdfBase64 || signedPdfUrl) && !isPublic"
                        class="btnFilter_2"
                        @click.stop.prevent="downloadSignedPdf"
                      >
                        {{ $t('mandate.download_pdf') || 'Télécharger le PDF' }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </page-outline>
    </div>
  </f7-page>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import QRCode from 'qrcode'
import IbanInput from '@/components/common/IbanInput.vue'
import { normalizeIban } from '@/helpers/iban'

export default {
  name: 'FormPageUnitDbtr',
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'iban-input': IbanInput
  },

  props: {
    token: {
      type: String,
      default: ''
    }
  },

  watch: {
    signedViewMode (newVal) {
      if (newVal) {
        this.generateQrCode()
      }
    }
  },

  data () {
    return {
      isPublic: false,
      forcedType: null,

      id_mandate: null,
      umr: '',
      message_type: '',
      mode_sign: '',
      docusignUrl: '',

      qrCodeDataUrl: '',   // image en base64 du QR
      qrTargetUrl: '',      // URL complète

      active: 'one_off',
      active_schema: 'core',
      ctr: '',
      reason_mandate: '',
      creation_date: '',

      showMandateLanguage: false,
      mandateLanguage: 'fr',
      mandatePdfLang: 'fr', // valeur exacte de lang renvoyée par getMandatDbtr

      mandateLanguageOptions: [
        { text: 'Deutsch', value: 'de' },
        { text: 'English', value: 'en' },
        { text: 'Español', value: 'es' },
        { text: 'Français', value: 'fr' },
        { text: 'Italiano', value: 'it' },
        { text: 'Português', value: 'pt' }
      ],

      mandateStatus: '',          // "1" (signé) ou "2" (refusé)
      signed_md_date: '',         // date de signature (API: signing_md_date)
      signing_cancel_date: '',    // date de refus (API: signing_cancel_date)

      cdtr_name: '',
      cdtr_id: '',
      cdtr_addr: '',
      cdtr_city: '',
      cdtr_country: '',

      email_reference: '',

      dbtr_name: '',
      dbtr_iban: '',
      dbtr_email: '',
      dbtr_addr: '',
      dbtr_city: '',
      dbtr_country: '',
      dbtr_bic: '',

      hasThirdPartyDebtor: false,
      dbtrPSP_bic: '',
      dbtrPSP_name: '',
      dbtrPSP_addr: '',
      dbtrPSP_city: '',
      dbtrPSP_ctry: '',

      showUmrControls: false,
      umrAutoChecked: true,
      umrManualChecked: false,
      umrManual: '',
      activateSpinner: false,
      isSubmitting: false,

      signedViewMode: false,
      signedPdfUrl: '',
      signedPdfFileName: '',
      signedPdfBase64: '',
      signed_date: '',
      urlAisp: '',
      tokenAisp: '',
      ibanAisp: '',

      countryOptions: [
        { iso2: 'FR', key: 'france' },
        { iso2: 'DE', key: 'allemagne' },
        { iso2: 'IT', key: 'italie' },
        { iso2: 'ES', key: 'espagne' },
        { iso2: 'BE', key: 'belgique' },
        { iso2: 'LU', key: 'luxembourg' },
        { iso2: 'NL', key: 'pays_bas' },
        { iso2: 'PT', key: 'portugal' },
        { iso2: 'IE', key: 'irlande' },
        { iso2: 'AT', key: 'autriche' },
        { iso2: 'FI', key: 'finlande' },
        { iso2: 'SE', key: 'suede' },
        { iso2: 'DK', key: 'danemark' },
        { iso2: 'NO', key: 'norvege' },
        { iso2: 'IS', key: 'islande' },
        { iso2: 'CH', key: 'suisse' },
        { iso2: 'PL', key: 'pologne' },
        { iso2: 'CZ', key: 'republique_tcheque' },
        { iso2: 'SK', key: 'slovaquie' },
        { iso2: 'SI', key: 'slovenie' },
        { iso2: 'HR', key: 'croatie' },
        { iso2: 'EE', key: 'estonie' },
        { iso2: 'LV', key: 'lettonie' },
        { iso2: 'LT', key: 'lituanie' },
        { iso2: 'MT', key: 'malte' },
        { iso2: 'CY', key: 'chypre' },
        { iso2: 'RO', key: 'roumanie' },
        { iso2: 'BG', key: 'bulgarie' },
        { iso2: 'HU', key: 'hongrie' },
        { iso2: 'GR', key: 'grece' }
      ]
    }
  },

  created () {
    const search = window.location.search || ''
    const params = new URLSearchParams(search)

    const encodedToken =
      this.token ||
      params.get('mToken') ||
      params.get('token') ||
      ''
    this.qrTargetUrl = window.location.href || ''

    if (encodedToken) {
      this.isPublic = true
      this.forcedType = 'dbtr'

      const decodedToken = this.decodeBase64Token(encodedToken)
      const { idMandat, umr } = this.parseMandateToken(decodedToken)

      if (idMandat && umr) {
        this.id_mandate = idMandat
        this.umr = umr
        this.getMandatDbtr({ id_mandat: idMandat, umr })
      } else {
        console.error('Token mandat invalide après décodage :', decodedToken)
        this.$f7?.alert?.(
          this.$t('errors.link_expired') || 'Lien invalide ou expiré.',
          this.$t('common.error') || 'Erreur'
        )
      }
    } else {
      this.isPublic = true
      this.forcedType = 'dbtr'
    }
  },

  computed: {
    type () {
      if (this.forcedType) return this.forcedType
      if (this.isPublic) return 'dbtr'
      const r = this.$route
      return (r && r.params && r.params.type) || 'dbtr'
    },
    isDbtr () {
      return this.type === 'dbtr'
    },
    isDisabled () {
      return this.isDbtr
    },
    canAccept () {
      const hasIban = (this.dbtr_iban || '').trim().length > 0
      const hasName = (this.dbtr_name || '').trim().length > 0
      const hasThirdBicOk = !this.hasThirdPartyDebtor ||
        ((this.dbtrPSP_bic || '').trim().length > 0)

      return hasIban && hasThirdBicOk && hasName
    },
    formattedCreationDate () {
      if (!this.creation_date) return ''
      return this.creation_date.split('T')[0]
    },
    // formattedSignedDate () {
    //   if (!this.signed_date) return ''
    //   return this.signed_date.split('T')[0]
    // }

    mandateStatusLabel () {
      const key = this.mandateStatus != null
        ? String(this.mandateStatus).trim()
        : ''

      if (!key) return '—'

      const i18nPath = `mandate_details.hist_status.status_${key}`

      if (this.$te ? this.$te(i18nPath) : true) {
        const translated = this.$t(i18nPath)

        if (translated && translated !== i18nPath) {
          return translated
        }
      }

      return key || 'Pending'
    },

    ctrDisplay () {
      const v = (this.ctr || '').toString().trim()
      if (!v || v === '$NotFound') return ''
      return v
    },
    outcomeDateLabel () {
     return this.mandateStatus === '2'
       ? (this.$t('mandate_details.date_refused') || 'Refused date')
       : (this.$t('mandate_details.date_signed') || 'Signed date')
   },
   formattedOutcomeDate () {
     // si refusé (status "2") -> signing_cancel_date, sinon -> signing_md_date
     const src = this.mandateStatus === '2'
       ? (this.signing_cancel_date || '')
       : (this.signed_md_date || this.signed_date || '')
     return src ? String(src).split('T')[0] : ''
   }
  },
  mounted () {
    const params = new URLSearchParams(window.location.search)
    const event = params.get('event')

    if (event === 'signing_complete') {
      this.handleSigningComplete()
    }
  },

  methods: {

    async handleSigningComplete () {
      try {
        console.log('DocuSign signing completed')

        // 1. Récupérer les paramètres présents dans l'URL
        const urlParams = new URLSearchParams(window.location.search)

        const event = urlParams.get('event')
        const mToken = urlParams.get('mToken')

        console.log('DocuSign event:', event)
        console.log('mToken:', mToken)

        // 2. Vérifier que DocuSign indique bien une signature terminée
        if (event !== 'signing_complete') {
          console.log('DocuSign event is not signing_complete:', event)
          return
        }

        // 3. Ici la signature DocuSign est terminée
        console.log('Mandate successfully signed with DocuSign')

        // 4. Nettoyer l'URL pour retirer &event=signing_complete
        // Cela évite de relancer handleSigningComplete()
        // si l'utilisateur refresh la page.
        if (mToken) {
          const cleanUrl =
            window.location.origin +
            window.location.pathname +
            '?mToken=' +
            encodeURIComponent(mToken)

          window.history.replaceState(
            {},
            document.title,
            cleanUrl
          )
        }

        // 5. Afficher le message de succès
        this.$f7.dialog.alert(
          this.$t('mandate.mandate_signed_successfully'),
          this.$t('common.success')
        )
      } catch (error) {
        console.error(
          'Error while handling DocuSign signing completion:',
          error
        )

        this.$f7.dialog.alert(
          'An error occurred after the DocuSign signature.',
          'Error'
        )
      }
    },
    // ---------- Helpers token ----------
    decodeBase64Token (raw) {
      if (!raw) return ''
      try {
        let base64 = String(raw).replace(/-/g, '+').replace(/_/g, '/')
        while (base64.length % 4 !== 0) base64 += '='
        const decoded = atob(base64)
        try {
          return decodeURIComponent(escape(decoded))
        } catch (e) {
          return decoded
        }
      } catch (e) {
        console.error('Erreur décodage base64 du token :', raw, e)
        return ''
      }
    },

    parseMandateToken (token) {
      const parts = String(token).split('_')
      if (parts.length < 3) return { idMandat: null, umr: null }
      const idMandat = parts[1]
      const umr = parts.slice(2).join('_')
      return { idMandat, umr }
    },

    // -----------QR Code ------------

    async generateQrCode () {
      try {
        // si pas encore défini, on prend l'URL courante
        if (!this.qrTargetUrl) {
          this.qrTargetUrl = window.location.href || ''
        }

        if (!this.qrTargetUrl) {
          console.warn('[QR] Aucune URL à encoder')
          return
        }

        // Génère une dataURL (image base64) pour l’<img>
        this.qrCodeDataUrl = await QRCode.toDataURL(this.qrTargetUrl, {
          margin: 1,
          width: 200
        })
      } catch (e) {
        console.error('[QR] Erreur génération QR code', e)
      }
    },

    // ---------- Call API : GET mandat ----------
    getMandatDbtr ({ id_mandat, umr }) {
      const params = { id_mandat, umr }
      this.activateSpinner = true

      return this.$engine.Mandat_dbtr.getMandatDbtr(params)
        .then((resp) => {
          const payload = (resp && resp.data) || {}
          let selected = {}

          if (Array.isArray(payload.Mandates) && payload.Mandates.length > 0) {
            selected = payload.Mandates[0]
          } else if (payload.Mandate) {
            selected = payload.Mandate
          } else if (payload.id_contract || payload.dbtr_name || payload.UMR) {
            selected = payload
          }

          if (!selected || Object.keys(selected).length === 0) return

          // reset mode par défaut
          this.signedViewMode = false
          this.signedPdfBase64 = ''
          this.signedPdfFileName = ''
          this.signedPdfUrl = ''

          // La langue du mandat provient du GET (ex. "PT").
          // Elle détermine aussi la langue de l'interface et le modèle PDF.
          this.mandatePdfLang = String(selected.lang || '').trim() || 'fr'
          const apiLang = this.mandatePdfLang.toLowerCase()
          const supportedLangs = ['de', 'en', 'es', 'fr', 'it', 'pt']
          this.mandateLanguage = supportedLangs.includes(apiLang) ? apiLang : 'fr'
          if (this.$i18n) {
            this.$i18n.locale = this.mandateLanguage
          }

          this.id_mandate = selected.id_mandate ?? this.id_mandate
          this.umr = selected.UMR ?? this.umr
          this.ctr = selected.id_contract ?? this.ctr
          this.mandateStatus =
            selected.status != null
              ? String(selected.status).trim()
              : ''
          this.reason_mandate = selected.reason_mandate ?? this.reason_mandate
          this.creation_date = selected.creation_date ?? this.creation_date
          this.message_type = selected.message_type ?? this.message_type
          this.mode_sign = selected.mode_sign != null ? String(selected.mode_sign).trim() : ''
          if (String(this.mode_sign) === '3') {
            this.getURLAispIban()
          }

          if (selected.type_transaction === 2) this.active = 'recurrent'
          else if (selected.type_transaction === 1) this.active = 'one_off'

          this.active_schema =
            (selected.schema_code || '').toUpperCase() === 'B2B'
              ? 'b2b'
              : 'core'

          this.cdtr_name = selected.cdtr_name || ''
          this.cdtr_id = selected.cdtr_id || ''
          this.cdtr_addr = selected.cdtr_addr || ''
          this.cdtr_city = selected.cdtr_city || ''
          this.cdtr_country = selected.cdtr_country || ''
          this.email_reference = selected.email_reference || ''

          this.dbtr_name = selected.dbtr_name || this.dbtr_name
          this.dbtr_iban = selected.dbtr_iban || this.dbtr_iban
          this.dbtr_email = selected.dbtr_email || this.dbtr_email
          this.dbtr_addr = selected.dbtr_addr || this.dbtr_addr
          this.dbtr_city = selected.dbtr_city || this.dbtr_city
          this.dbtr_country = selected.dbtr_country.toUpperCase() || this.dbtr_country.toUpperCase() || "FR"
          // this.dbtr_country = this.iso2ToCountryName(selected.dbtr_country) || this.iso2ToCountryName(this.dbtr_country)
          // this.dbtr_bic = selected.dbtrPSP_BIC || this.dbtr_bic
          this.dbtr_bic = selected.dbtr_bic || this.dbtr_bic

          this.dbtrPSP_bic  = selected.dbtrPSP_bic  || selected.dbtrPSP_BIC || this.dbtrPSP_bic
          this.dbtrPSP_name = selected.dbtrPSP_name || this.dbtrPSP_name
          this.dbtrPSP_addr = selected.dbtrPSP_addr || this.dbtrPSP_addr
          this.dbtrPSP_city = selected.dbtrPSP_city || this.dbtrPSP_city
          this.dbtrPSP_ctry = selected.dbtrPSP_ctry || this.dbtrPSP_ctry


          this.hasThirdPartyDebtor = Boolean(
            // Flag éventuel renvoyé par l’API
            selected.is_third_party_debtor ||
            selected.isThirdPartyDebtor ||
            // Ou déduction via les champs PSP
            this.dbtrPSP_name ||
            this.dbtrPSP_bic ||
            this.dbtrPSP_addr ||
            this.dbtrPSP_city ||
            this.dbtrPSP_ctry
          )
          this.signed_md_date      = selected.signing_md_date      || ''
          this.signing_cancel_date = selected.signing_cancel_date  || ''

          // date de signature si fournie par l'API
          this.signed_date =
            selected.signing_md_date ||
            selected.signed_date ||
            selected.signature_date ||
            this.signed_date

            // ---------- Détermination du mode selon le status ----------

          // Status principal
          let mandateStatus = selected.status

          // Optionnel : si pas de status au niveau racine, on prend le dernier de l'historique
          if (
            (!mandateStatus || mandateStatus === '') &&
            Array.isArray(selected.History) &&
            selected.History.length > 0
          ) {
            const lastHistory = selected.History.reduce((latest, h) => {
              if (!latest) return h
              const d1 = new Date(latest.creation_date)
              const d2 = new Date(h.creation_date)
              return d2 > d1 ? h : latest
            }, null)

            if (lastHistory && lastHistory.status != null) {
              mandateStatus = lastHistory.status
            }
          }

          // const statusStr = (mandateStatus != null ? String(mandateStatus) : '').trim()
          const statusStr = (mandateStatus != null ? String(mandateStatus) : '').trim()
          this.mandateStatus = statusStr

          // Règle métier : si status ≠ 6 ET status ≠ 0 => vue signée (lecture seule)
          const mustBeSignedView =
            statusStr !== '' &&
            statusStr !== '6' &&
            statusStr !== '0'

          // Reset valeurs PDF par défaut
          this.signedViewMode = false
          this.signedPdfBase64 = ''
          this.signedPdfFileName = ''
          this.signedPdfUrl = ''

          // Si on doit être en mode signé, on active le mode et on charge le PDF si présent
          if (mustBeSignedView) {
            const doc = (selected.document || '').toString().trim()

            if (doc) {
              const cleanBase64 = doc
                .replace(/^data:application\/pdf;base64,/, '')
                .replace(/\s/g, '')

              this.signedPdfBase64 = cleanBase64
              this.signedPdfFileName =
                selected.document_name ||
                this.buildSignedPdfFileName() ||
                'mandate_signed.pdf'

              this.signedPdfUrl = `data:application/pdf;base64,${cleanBase64}`
            }

            this.signedViewMode = true

            console.log(
              '[Mandate] passage en mode signé via status',
              'status =', statusStr,
              'pdfLen =', this.signedPdfBase64.length,
              'file =', this.signedPdfFileName
            )
          } else {
            console.log(
              '[Mandate] mode édition (non signé)',
              'status =', statusStr || '(vide)'
            )
          }
        })
        .catch((e) => {
          console.error(e)
          this.$f7?.alert?.(
            this.$t('errors.link_expired') || 'Lien invalide ou expiré.',
            this.$t('common.error') || 'Erreur'
          )
        })
        .finally(() => {
          this.activateSpinner = false
          this.$f7?.pullToRefreshDone?.()
        })
    },

    // Récupère le modèle PDF du serveur pour la langue du mandat.
    async getMandatPDF () {
      const params = {
        id_mandat: this.id_mandate,
        umr: this.umr,
        getpdf: 1,
        lang: this.mandatePdfLang
      }
      const response = await this.$engine.Mandat_dbtr.getMandatPDF(params)
      const payload = response?.data ?? response
      const pdfDefault = payload?.pdfDefault ?? payload?.data?.pdfDefault

      if (typeof pdfDefault !== 'string' || !pdfDefault.trim()) {
        throw new Error('getMandatPDF : pdfDefault absent ou vide dans la réponse')
      }

      return pdfDefault.trim().replace(/^data:application\/pdf;base64,/i, '').replace(/\s/g, '')
    },

    async generateMandatePdfBase64 ({ label = 'Signed by', labelColor = rgb(0, 0, 0) } = {}) {
      // Seul le modèle change : les champs, mentions et la suite du parcours restent inchangés.
      const templateBase64 = await this.getMandatPDF()
      const templateBytes = Uint8Array.from(atob(templateBase64), c => c.charCodeAt(0))
      const pdfDoc = await PDFDocument.load(templateBytes)

      const [page] = pdfDoc.getPages()
      const { height } = page.getSize()

      const font = await pdfDoc.embedFont(StandardFonts.Courier)
      const fontBold = await pdfDoc.embedFont(StandardFonts.Courier)

      const baseOpts = { size: 11, font, color: rgb(0, 0, 0) }
      const write = (text, x, y, opts = {}) => {
        page.drawText(text != null ? String(text) : '', { x, y, ...baseOpts, ...opts })
      }
      const value = v => (v == null ? '' : String(v))

      const {
        umr,
        cdtr_name,
        cdtr_id,
        cdtr_addr,
        cdtr_city,
        cdtr_country,
        dbtr_name,
        dbtr_email,
        email_reference,
        dbtr_addr,
        dbtr_city,
        dbtr_country,
        dbtr_iban,
        dbtr_bic,
        active,
        hasThirdPartyDebtor,
        dbtrPSP_name,
        dbtrPSP_addr,
        dbtrPSP_city,
        dbtrPSP_ctry,
        dbtrPSP_bic
      } = this

      const todayStr = new Date().toISOString().slice(0, 10)

      const leftLabelX = 40
      const valueX = 185
      const lineStep = 27

      write(`${value(umr)}`, leftLabelX + 60, height - 65, { font: fontBold, size: 14 })

      let y = height - 130
      write(value(dbtr_name), valueX, y); y -= lineStep
      write(value(dbtr_email), valueX, y); y -= lineStep
      write(value(dbtr_addr), valueX, y); y -= lineStep
      write(value(dbtr_city), valueX, y); y -= lineStep
      write(value(dbtr_country), valueX, y); y -= (lineStep + 60)

      write(value(dbtr_iban), valueX, y); y -= (lineStep + 8)
      write(value(dbtr_bic), valueX, y); y -= lineStep

      const paymentType = active === 'recurrent' ? 'Recurrent' : (active === 'one_off' ? 'One-off' : '')
      write(value(paymentType), valueX, y); y -= (lineStep + 40)

      // --- Bloc PSP (tiers débiteur) ---
      if (hasThirdPartyDebtor) {
        // Si les infos existent, on les met, sinon value() renvoie ''
        write(value(dbtrPSP_name), valueX, y); y -= lineStep
        write(value(dbtrPSP_addr),  valueX, y); y -= lineStep
        write(value(dbtrPSP_city), valueX, y); y -= lineStep
        write(value(dbtrPSP_ctry), valueX, y); y -= (lineStep + 30)
      } else {
        // Pas de PSP : on écrit des lignes vides pour garder l'espacement
        write('', valueX, y); y -= lineStep
        write('', valueX, y); y -= lineStep
        write('', valueX, y); y -= lineStep
        write('', valueX, y); y -= (lineStep + 30)
      }

      write(value(cdtr_name), valueX, y); y -= (lineStep - 10)
      write(value(`${cdtr_addr} - ${cdtr_city} - ${cdtr_country}`), valueX, y); y -= (lineStep - 10)
      const cdtrIdX = this.mandateLanguage === 'fr'
        ? valueX + 35
        : valueX

      write(value(cdtr_id), cdtrIdX, y); y -= (lineStep + 138)
      //write(value(cdtr_id), valueX, y); y -= (lineStep + 138)

      // --- COMMITMENT : texte anglais dans la zone prévue du modèle PDF ---
      // Le bloc Signed by / Rejected by et la date restent à leur position actuelle.
      const commitmentFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
      const commitmentBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold)
      const commitmentParagraphsEn = [
        [
          ['By signing this mandate form, you authorise (A) ', false],
          [value(cdtr_name), true],
          [' to send instructions to your bank to debit your account, and (B) your bank to debit your account in accordance with the instructions from ', false],
          [value(cdtr_name), true],
          ['.', false]
        ],
        [
          ['You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within ', false],
          ['8 weeks', true],
          [' starting from the date on which your account was debited for an authorised direct debit.', false]
        ],
        [
          ['The information contained in this mandate is intended to be used by the creditor solely for the purpose of managing its relationship with its customer. The customer may exercise their rights to object, access, erasure, data portability, restriction of processing and rectification, as provided for in ', false],
          ['Articles 38 et seq. of French Law No. 78-17 of 6 January 1978 relating to information technology, files and civil liberties', true],
          [', by contacting the following email address: ', false],
          [value(email_reference), true],
          ['.', false]
        ]
      ]

      const commitmentParagraphsFr = [
        [
          ['En signant ce formulaire de mandat, vous autorisez (A) ', false],
          [value(cdtr_name), true],
          [' à envoyer des instructions à votre banque pour débiter votre compte, et (B) votre banque à débiter votre compte conformément aux instructions de ', false],
          [value(cdtr_name), true],
          ['.', false]
        ],
        [
          ['Vous bénéficiez d’un droit au remboursement par votre banque selon les conditions décrites dans la convention que vous avez passée avec elle. Une demande de remboursement doit être présentée dans les ', false],
          ['8 semaines', true],
          [' suivant la date de débit de votre compte pour un prélèvement autorisé.', false]
        ],
        [
          ['Les informations contenues dans le présent mandat sont destinées à être utilisées par le créancier uniquement pour la gestion de sa relation avec son client. Le client peut exercer ses droits d’opposition, d’accès, d’effacement, de portabilité des données, de limitation du traitement et de rectification, conformément aux ', false],
          ['articles 38 et suivants de la loi française n° 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés', true],
          [', en contactant l’adresse électronique suivante : ', false],
          [value(email_reference), true],
          ['.', false]
        ]
      ]

      const commitmentParagraphs =
        this.mandateLanguage === 'fr'
          ? commitmentParagraphsFr
          : commitmentParagraphsEn

      // Découpe le texte selon la largeur disponible, sans couper les mots.
      const layoutCommitment = (fontSize) => {
        const commitmentLeft = 60
        const commitmentRight = 60
        const maxWidth = page.getWidth() - commitmentLeft - commitmentRight
        const lines = []
        commitmentParagraphs.forEach((paragraph, paragraphIndex) => {
          let line = []
          let lineWidth = 0
          paragraph.forEach(([text, bold]) => {
            const selectedFont = bold ? commitmentBoldFont : commitmentFont
            const words = text.match(/\S+\s*/g) || []
            words.forEach(word => {
              const chunk = word.replace(/\s+$/, '')
              const space = lineWidth === 0 ? '' : ' '
              const width = selectedFont.widthOfTextAtSize(space + chunk, fontSize)
              if (lineWidth > 0 && lineWidth + width > maxWidth) {
                lines.push({ chunks: line, paragraphEnd: false })
                line = []
                lineWidth = 0
              }
              const part = lineWidth === 0 ? chunk : space + chunk
              line.push({ text: part, font: selectedFont })
              lineWidth += selectedFont.widthOfTextAtSize(part, fontSize)
            })
          })
          lines.push({ chunks: line, paragraphEnd: paragraphIndex < commitmentParagraphs.length - 1 })
        })
        return lines
      }

      const commitmentTop = height - 680
      const signedByY = y - 10
      const commitmentBottom = signedByY  // garde une marge avant Signed by
      let commitmentSize = 9
      let commitmentLines = layoutCommitment(commitmentSize)
      const commitmentHeight = size => commitmentLines.length * size * 1.2 + 2 * 3
      while (commitmentSize > 7.2 && commitmentTop - commitmentHeight(commitmentSize) < commitmentBottom) {
        commitmentSize = Math.max(7.2, commitmentSize - 0.2)
        commitmentLines = layoutCommitment(commitmentSize)
      }
      let commitmentY = commitmentTop
      const commitmentLineHeight = commitmentSize * 1.2
      commitmentLines.forEach(line => {
        let commitmentX = 60
        line.chunks.forEach(chunk => {
          page.drawText(chunk.text, {
            x: commitmentX,
            y: commitmentY,
            size: commitmentSize,
            font: chunk.font,
            color: rgb(0, 0, 0)
          })
          commitmentX += chunk.font.widthOfTextAtSize(chunk.text, commitmentSize)
        })
        commitmentY -= commitmentLineHeight + (line.paragraphEnd ? 3 : 0)
      })


      // // Afficher la ligne si :
      // // - mandat rejeté, quel que soit le mode
      // // - OU mandat signé avec mode_sign = 3
      // const showSignatureLine =
      //   label === 'Rejected by' ||
      //   (label === 'Signed by' && String(this.mode_sign) === '3')
      //
      // if (showSignatureLine) {
      //   write(`${label}: ${value(dbtr_name)}`, leftLabelX + 15, signedByY, {
      //     font: fontBold,
      //     size: 13,
      //     color: labelColor
      //   })
      //
      //   const signatureLineY = signedByY - lineStep + 10
      //   write(value(todayStr), leftLabelX + 80, signatureLineY)
      // }
      // Signed by : uniquement mode 3
      // Rejected by : tous les modes
      const showSignatureLine =
        label === 'Rejected by' ||
        (label === 'Signed by' && String(this.mode_sign) === '3')

      if (showSignatureLine) {
        write(`${label}: ${value(dbtr_name)}`, leftLabelX + 15, signedByY, {
          font: fontBold,
          size: 13,
          color: labelColor
        })
      }

      // Date toujours affichée, quel que soit le mode
      const signatureLineY = signedByY - lineStep + 10

      const today = new Date()
      const formattedToday =
        String(today.getDate()).padStart(2, '0') + '/' +
        String(today.getMonth() + 1).padStart(2, '0') + '/' +
        today.getFullYear()

        write(
          `${this.mandateLanguage === 'fr' ? 'Le' : 'On'}: ${formattedToday}`,
          leftLabelX + 15,
          signatureLineY,
          {
            font: fontBold,
            size: 11,
            color: rgb(0, 0, 0)
          }
        )


      const pdfBase64 = await pdfDoc.saveAsBase64({ dataUri: false })
      return pdfBase64
    },

    buildOutcomePdfFileName (outcome = 'signed') {
      const now = new Date()
      const yyyy = String(now.getFullYear())
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')

      const hh = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      const xxx = String(now.getMilliseconds()).padStart(3, '0')

      const dateStr = `${yyyy}${mm}${dd}${hh}${min}${ss}${xxx}`

      const contractId =
        (this.ctr || '').toString().trim() ||
        (this.id_mandate || '').toString().trim() ||
        (this.umr || '').toString().trim() ||
        'mandate'

      return `${dateStr}_${contractId}_${outcome}.pdf`
    },

    // ---------- Après succès signature ----------
    enterSignedView (mandatePdfBase64, fileName) {
      this.signedPdfFileName = fileName || 'mandate_signed.pdf'
      this.signedPdfBase64 = mandatePdfBase64
      this.signedPdfUrl = `data:application/pdf;base64,${mandatePdfBase64}`

      if (!this.signed_date) {
        this.signed_date = new Date().toISOString().slice(0, 10)
      }

      this.signedViewMode = true

      this.generateQrCode()

      if (this.id_mandate && this.umr) {
        this.getMandatDbtr({ id_mandat: this.id_mandate, umr: this.umr })
      }
    },

    // ---------- Accept & Sign ----------
    async onSend () {
      if (!this.canAccept || this.isSubmitting) return
      if (this.hasThirdPartyDebtor && !(this.dbtrPSP_bic || '').trim()) {
        this.$f7?.dialog?.alert(
          'Third party debtor BIC is required.',
          this.$t('common.error') || 'Error'
        )
        return
      }
      // --- Validation IBAN via le composant ---
      const rawIban = this.dbtr_iban || ''
      const normIban = normalizeIban(rawIban)
      if (normIban) {
        const ibanComp = this.$refs.dbtrIbanInput
        if (ibanComp) {
          const ok = ibanComp.validate(true)  // affiche l’erreur sous le champ si besoin
          if (!ok) {
            const ibanComp = this.$refs.dbtrIbanInput
            const msg = (ibanComp && ibanComp.error) ||
                        (this.$t && this.$t('errors.iban_invalid')) ||
                        'IBAN invalide'

            this.$f7.modal({
              title: this.$t('common.error') || 'Erreur',
              text: msg,
              buttons: [{ text: 'OK' }]
            })
            return
          }
        }
      }
      this.isSubmitting = true

      try {
        const dbtrCountryIso = this.countryNameToISO2(this.dbtr_country)

        const mandatePdfBase64 = await this.generateMandatePdfBase64({ label: 'Signed by', labelColor: rgb(0,0,0) })
        const mandatePdfFileName = this.buildOutcomePdfFileName('signed')
        // const mandatePdfBase64 = await this.generateMandatePdfBase64()
        // const mandatePdfFileName = this.buildSignedPdfFileName()
        const todayStr = new Date().toISOString().slice(0, 10)

        const params = {
          id_mandate: this.id_mandate,
          UMR: this.umr,
          mode: 'Signed',

          dbtr_name: (this.dbtr_name || '').trim(),
          ...(this.dbtr_iban ? { dbtr_iban: this.dbtr_iban.trim() } : {}),
          ...(this.dbtr_addr ? { dbtr_addr: this.dbtr_addr.trim() } : {}),
          ...(this.dbtr_city ? { dbtr_city: this.dbtr_city.trim() } : {}),
          ...(this.dbtr_email ? { dbtr_email: this.dbtr_email.trim() } : {}),
          // ...(this.dbtr_bic ? { dbtrPSP_BIC: this.dbtr_bic.trim() } : {}),
          ...(this.dbtr_bic ? { dbtr_bic: this.dbtr_bic.trim() } : {}),
          ...(dbtrCountryIso ? { dbtr_country: dbtrCountryIso } : {}),

          ...(this.cdtr_name ? { cdtr_name: this.cdtr_name } : {}),
          ...(this.cdtr_id ? { cdtr_id: this.cdtr_id } : {}),

          mandate_language: this.mandateLanguage,

          // tiers débiteur
          ...(this.hasThirdPartyDebtor ? {
            is_third_party_debtor: true
          } : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_name
            ? { dbtrPSP_name: this.dbtrPSP_name.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_bic
            ? { dbtrPSP_bic: this.dbtrPSP_bic.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_addr
            ? { dbtrPSP_addr: this.dbtrPSP_addr.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_city
            ? { dbtrPSP_city: this.dbtrPSP_city.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_ctry
            ? { dbtrPSP_ctry: this.dbtrPSP_ctry.trim() }
            : {}),

          mandate_pdf_base64: mandatePdfBase64,
          mandate_pdf_filename: mandatePdfFileName,
          signed_date: todayStr
        }

        console.log('===== DEBUG addMandatDbtr =====')

        console.log('Mandate ID:', params.id_mandate)
        console.log('UMR:', params.UMR)
        console.log('Mode:', params.mode)

        console.log(
          'PDF Base64 length:',
          params.mandate_pdf_base64?.length
        )

        console.log(
          'PDF size (KB):',
          Math.round(
            params.mandate_pdf_base64.length * 3 / 4 / 1024
          )
        )

        console.log(
          'POST payload size (KB):',
          Math.round(
            new Blob([JSON.stringify(params)]).size / 1024
          )
        )

        console.time('addMandatDbtr')

        try {
          const response = await this.addMandatDbtr(params)
          console.timeEnd('addMandatDbtr')
          console.log('POST success:', response)
        } catch (error) {
          console.timeEnd('addMandatDbtr')
          console.error('POST failed:', {
            status: error.response?.status,
            message: error.message,
            response: error.response?.data
          })
          throw error
        }

        await this.addMandatDbtr(params)

        // DocuSign URL : après le POST du mandat, on crée l'envelope.
        // La réponse attendue est { url: "https://..." }.
        // Dès que l'URL est reçue, l'iframe DocuSign remplace automatiquement le formulaire.
        if (String(this.mode_sign) === '1') {
          const envelopeResponse = await this.createEnvelope({
            IdMandate: this.id_mandate,
            mode: 'url'
          })

          // Selon le wrapper HTTP/engine, la réponse peut être directement { url }
          // ou être placée dans response.data.
          const signUrl = envelopeResponse && (
            envelopeResponse.url ||
            (envelopeResponse.data && envelopeResponse.data.url)
          )

          if (!signUrl) {
            throw new Error('DocuSign createEnvelope: URL de signature absente de la réponse')
          }

          //this.docusignUrl = signUrl
          window.location.href = signUrl
          return
        }

        // Autres modes de signature : comportement existant.
        this.$f7.modal({
          title: this.$t('mandate.signed_success') || 'Mandate signed successfully',
          text: this.$t('common.success') || 'Success!',
          buttons: [
            {
              text: 'OK',
              onClick: () => {
                this.enterSignedView(mandatePdfBase64, mandatePdfFileName)
              }
            }
          ]
        })
      } catch (e) {
          console.error('Erreur addMandatDbtr:', e)

          const status =
            e?.response?.status ||
            e?.status

          const errorData =
            e?.response?.data ||
            e?.data ||
            e

          console.log('status:', status)
          console.log('errorData:', errorData)

          if (
            status === 422 &&
            (
              errorData?.errorCode === 'BLACKLIST_MATCH' ||
              errorData?.message === 'match_blacklist_dbtr'
            )
          ) {
            this.$f7.modal({
              title: this.$t('common.error') || 'Erreur',
              text: this.$t('mandate.match_blacklist_dbtr'),
              buttons: [
                {
                  text: 'OK'
                }
              ]
            })

            return
          }

          // Autres erreurs
          this.$f7.modal({
            title: this.$t('common.error') || 'Erreur',
            text: this.$t('errors.generic') || 'Une erreur est survenue.',
            buttons: [
              {
                text: 'OK'
              }
            ]
          })
        } finally {
          this.isSubmitting = false
        }
    },

    // ---------- Refuse ----------
    async onRefuse () {
      if (this.isSubmitting) return
      this.isSubmitting = true

      try {
        const dbtrCountryIso = this.countryNameToISO2(this.dbtr_country)

        // 1) Générer le PDF "Rejected by" (rouge)
        const mandatePdfBase64 = await this.generateMandatePdfBase64({
          label: 'Rejected by',
          labelColor: rgb(0.85, 0, 0) // rouge
        })
        const mandatePdfFileName = this.buildOutcomePdfFileName('rejected')
        const todayStr = new Date().toISOString().slice(0, 10)

        // 2) Appel API avec mode=Rejected + PDF (mêmes champs que le sign)
        const params = {
          id_mandate: this.id_mandate,
          UMR: this.umr,
          mode: 'Rejected',

          ...(this.dbtr_name ? { dbtr_name: this.dbtr_name.trim() } : {}),
          ...(this.dbtr_iban ? { dbtr_iban: this.dbtr_iban.trim() } : {}),
          ...(this.dbtr_addr ? { dbtr_addr: this.dbtr_addr.trim() } : {}),
          ...(this.dbtr_city ? { dbtr_city: this.dbtr_city.trim() } : {}),
          ...(dbtrCountryIso ? { dbtr_country: dbtrCountryIso } : {}),
          ...(this.dbtr_bic ? { dbtr_bic: this.dbtr_bic.trim() } : {}),

          // tiers débiteur
          ...(this.hasThirdPartyDebtor ? {
            is_third_party_debtor: true
          } : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_name
            ? { dbtrPSP_name: this.dbtrPSP_name.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_bic
            ? { dbtrPSP_bic: this.dbtrPSP_bic.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_addr
            ? { dbtrPSP_addr: this.dbtrPSP_addr.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_city
            ? { dbtrPSP_city: this.dbtrPSP_city.trim() }
            : {}),
          ...(this.hasThirdPartyDebtor && this.dbtrPSP_ctry
            ? { dbtrPSP_ctry: this.dbtrPSP_ctry.trim() }
            : {}),

          // mêmes payloads que la signature pour rester ISO-API
          mandate_pdf_base64: mandatePdfBase64,
          mandate_pdf_filename: mandatePdfFileName,
          signed_date: todayStr // si ton back préfère rejected_date, adapte ici
        }

        await this.addMandatDbtr(params)

        // 3) UI : message + bascule en vue signée avec le PDF
        this.$f7.modal({
          title: this.$t('mandate.refused') || 'Mandate refused',
          buttons: [
            {
              text: 'OK',
              onClick: () => {
                this.enterSignedView(mandatePdfBase64, mandatePdfFileName)
              }
            }
          ]
        })
      } catch (e) {
        console.error(e)
        this.$f7?.dialog?.alert(
          this.$t('errors.generic') || 'Une erreur est survenue.',
          this.$t('common.error') || 'Erreur'
        )
      } finally {
        this.isSubmitting = false
      }
    },

    // ---------- Utils ----------
    countryNameToISO2 (name) {
      if (!name) return ''
      const trimmed = name.trim()

      if (/^[A-Z]{2}$/.test(trimmed)) return trimmed
      if (/^[a-z]{2}$/.test(trimmed)) return trimmed.toUpperCase()

      const n = trimmed.toLowerCase()
      const map = {
        france: 'FR',
        allemagne: 'DE', germany: 'DE',
        italie: 'IT', italy: 'IT',
        espagne: 'ES', spain: 'ES',
        belgique: 'BE', belgium: 'BE',
        luxembourg: 'LU',
        'pays-bas': 'NL', 'pays bas': 'NL', netherlands: 'NL',
        portugal: 'PT',
        irlande: 'IE', ireland: 'IE',
        autriche: 'AT', austria: 'AT',
        finlande: 'FI', finland: 'FI',
        'suède': 'SE', suede: 'SE', sweden: 'SE',
        danemark: 'DK', denmark: 'DK',
        'norvège': 'NO', norvege: 'NO', norway: 'NO',
        islande: 'IS', iceland: 'IS',
        suisse: 'CH', switzerland: 'CH',
        pologne: 'PL', poland: 'PL',
        'république tchèque': 'CZ', 'republique tcheque': 'CZ',
        czechia: 'CZ', 'czech republic': 'CZ',
        slovaquie: 'SK', slovakia: 'SK',
        slovénie: 'SI', slovenie: 'SI', slovenia: 'SI',
        croatie: 'HR', croatia: 'HR',
        estonie: 'EE', estonia: 'EE',
        lettonie: 'LV', latvia: 'LV',
        lituanie: 'LT', lithuania: 'LT',
        malte: 'MT', malta: 'MT',
        chypre: 'CY', cyprus: 'CY',
        roumanie: 'RO', romania: 'RO',
        bulgarie: 'BG', bulgaria: 'BG',
        hongrie: 'HU', hungary: 'HU',
        'grèce': 'GR', grece: 'GR', greece: 'GR'
      }

      return map[n] || ''
    },

    downloadSignedPdf () {
      console.log('[downloadSignedPdf] click', {
        hasBase64: !!this.signedPdfBase64,
        len: this.signedPdfBase64 ? this.signedPdfBase64.length : 0,
        fileName: this.signedPdfFileName
      })

      try {
        if (!this.signedPdfBase64) {
          console.error('Aucun PDF signé disponible pour le téléchargement')
          this.$f7?.dialog?.alert(
            this.$t('mandate.no_pdf') || 'Aucun document disponible.',
            this.$t('common.error') || 'Erreur'
          )
          return
        }

        // 1) Nettoyage base64 (juste au cas où)
        const cleanBase64 = this.signedPdfBase64
          .replace(/^data:application\/pdf;base64,/, '')
          .replace(/\s/g, '')

        console.log('[downloadSignedPdf] cleaned len', cleanBase64.length)

        // 2) Tentative de décodage base64 -> bytes
        let byteCharacters
        try {
          byteCharacters = atob(cleanBase64)
        } catch (err) {
          console.error('Base64 invalide pour le PDF :', err)
          this.$f7?.dialog?.alert(
            this.$t('mandate.invalid_pdf')
              || 'Le document PDF reçu est invalide (base64).',
            this.$t('common.error') || 'Erreur'
          )
          return
        }

        const byteArray = new Uint8Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i)
        }

        // 3) Création du Blob PDF
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)

        console.log('[downloadSignedPdf] blob url', url)

        // 4) Tentative 1 : téléchargement direct (navigate via <a download>)
        const a = document.createElement('a')
        a.href = url
        a.download = this.signedPdfFileName || 'mandate_signed.pdf'
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        // 5) Fallback : si l’environnement ignore le download,
        //    on ouvre au moins le PDF dans un nouvel onglet / viewer.
        //    (Ne génère pas l’erreur "Not allowed to navigate top frame to data URL"
        //     car ici c’est un blob:, pas un data:)
        setTimeout(() => {
          // Heuristique : si rien ne s’est passé, laisser l’utilisateur voir le PDF
          const win = window.open(url, '_blank')
          if (!win || win.closed || typeof win.closed === 'undefined') {
            console.warn('[downloadSignedPdf] Impossible d’ouvrir dans un nouvel onglet (popup bloquée ?)')
          }
        }, 500)

        // 6) Cleanup
        setTimeout(() => {
          URL.revokeObjectURL(url)
          console.log('[downloadSignedPdf] blob url revoked')
        }, 10000)
      } catch (e) {
        console.error('Erreur lors du téléchargement du PDF signé', e)
        this.$f7?.dialog?.alert(
          this.$t('errors.generic') || 'Une erreur est survenue lors du téléchargement.',
          this.$t('common.error') || 'Erreur'
        )
      }
    },

    addMandatDbtr (params) {
      return this.$engine.Mandat_dbtr.addMandatDbtr(params)
    },
    createEnvelope (params) {
      return this.$engine.Mandat.createEnvelope(params)
    },
    iso2ToCountryName (code) {
      if (!code) return ''
      const c = String(code).trim().toUpperCase()
      const map = {
        FR: 'France',
        DE: 'Germany',
        IT: 'Italy',
        ES: 'Spain',
        BE: 'Belgium',
        LU: 'Luxembourg',
        NL: 'Netherlands',
        PT: 'Portugal',
        IE: 'Ireland',
        AT: 'Austria',
        FI: 'Finland',
        SE: 'Sweden',
        DK: 'Denmark',
        NO: 'Norway',
        IS: 'Iceland',
        CH: 'Switzerland',
        PL: 'Poland',
        CZ: 'Czech Republic',
        SK: 'Slovakia',
        SI: 'Slovenia',
        HR: 'Croatia',
        EE: 'Estonia',
        LV: 'Latvia',
        LT: 'Lithuania',
        MT: 'Malta',
        CY: 'Cyprus',
        RO: 'Romania',
        BG: 'Bulgaria',
        HU: 'Hungary',
        GR: 'Greece'
      }
      return map[c] || code // fallback: on renvoie le code brut si inconnu
    },
    async getURLAisp() {
      const responseAisp = await this.$engine.Mandat.addAispToken({
        id_mandate: this.id_mandate
      })
      this.urlAisp = responseAisp.data.url
      this.tokenAisp = responseAisp.data.token
    },
    async getURLAispIban() {
     await this.getURLAisp()
     let params = {
       token: this.tokenAisp
     }
     const responseAispIban = await this.$engine.Mandat.addAispIban(params)
     this.dbtr_iban = responseAispIban.data.Iban
   },
    openAisp () {
      if (!this.urlAisp) return
      window.location.href = this.urlAisp
    }
  }
}
</script>

<style scoped>
.mandate-dbtr-wrapper {
  margin-top: 40px;
}

.docusign-signing-container {
  width: 100%;
  min-height: 80vh;
}

.docusign-signing-iframe {
  display: block;
  width: 100%;
  height: 80vh;
  min-height: 700px;
  border: 0;
}
</style>
